$(function(){
    setTimeout(function(){
        $('#jsd-widget').addClass('show');
        $('#scrollToTopBtn').css({'display':'block'});
    }, 3000);
});